import { env } from "../config/env";
import { createClient } from "./http";

const api = createClient(env.CATALOG_BASE_URL);

export const inventoryService = {
 async listStockSummary({ warehouseId = "", productId = "", page = 1, limit = 20 } = {}) {
  const offset = Math.max(0, (Number(page) - 1) * Number(limit));
  const params = { limit, offset };

  if (warehouseId) params.warehouseId = warehouseId;
  if (productId) params.productId = productId;

  return api.get("/api/admin/inventory/stock", { params });
},

  async listBatches({ warehouseId, productId } = {}) {
    if (!warehouseId || !productId) {
      throw new Error("warehouseId and productId are required");
    }
    return api.get("/api/admin/inventory/batches", {
      params: { warehouseId, productId },
    });
  },

  async createInboundReceipt(payload) {
    return api.post("/api/admin/inventory/inbound", payload);
  },

  async listInboundReceipts({
    warehouseId = "",
    status = "",
    page = 1,
    limit = 20,
  } = {}) {
    const offset = Math.max(0, (Number(page) - 1) * Number(limit));
    const params = { limit, offset };
    if (warehouseId) params.warehouseId = warehouseId;
    if (status) params.status = status;
    return api.get("/api/admin/inventory/inbound", { params });
  },

  async getInboundReceipt(id) {
    if (!id) throw new Error("Receipt id is required");
    return api.get(`/api/admin/inventory/inbound/${id}`);
  },

  async confirmInboundReceipt(id, payload) {
    if (!id) throw new Error("Receipt id is required");
    return api.post(`/api/admin/inventory/inbound/${id}/confirm`, payload);
  },

  async listWarehouseOrders({
    warehouseId = "",
    status = "",
    page = 1,
    limit = 20,
  } = {}) {
    const offset = Math.max(0, (Number(page) - 1) * Number(limit));
    const params = { limit, offset };
    if (warehouseId) params.warehouseId = warehouseId;
    if (status) params.status = status;
    return api.get("/api/admin/warehouse-orders", { params });
  },

  async getWarehouseOrder(id) {
    if (!id) throw new Error("Order id is required");
    return api.get(`/api/admin/warehouse-orders/${id}`);
  },

  async decideWarehouseOrder(id, payload) {
    if (!id) throw new Error("Order id is required");
    return api.post(`/api/admin/warehouse-orders/${id}/decide`, payload);
  },
};